<template>
	<div style="padding-top: -2px; margin-top: -2px">
		<vc-select-generic
			ref="scostcenter"
			autocomplete
			class="text"
			itemtext="CceName"
			itemvalue="CceID"
			:disabled="disabled"
			id="CceName"
			:value="value"
			:return-object="returnObject"
			@input="input($event)"
			:config="config"
			:label="label"
			:full="full"
			:autofocus="autofocus"
			:text="text"
			:clearable="clearable"
			:noDefault="noDefault"
			:outlined="outlined"
			@updateData="updateData($event)"
		></vc-select-generic>
	</div>
</template>

<script>
	import _sCostCenter from "@/services/General/GenCostCenterService.js"

	export default {
		name: "SelectCostcenter",
		props : {
			autofocus: {
				type: Boolean,
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			clearable: {
				type: Boolean,
				default: false,
			},
			value: null,
			text: {
				type: String,
				default: ""
			},
			label: {
				type: String,
				default: "",
			},
			returnObject: {
				type: Boolean,
				default: false,
			},
			noDefault: {
				type: Boolean,
				default: false,
			},
			full: {
				type: Boolean,
				default: false,
			},

			outlined: {
				type: Boolean,
				default: true
			},
			CceLevel : {
				type : Number,
				default : 100
			}
		},
		data() {
			return {
				item: 0,
				val: "",
				items: [],
				config: {},
			}
		},
		watch: {
			value(value) {
				this.item = value;
			},
		},

		methods: {
			focus() {
				this.$refs.sarea.focus();
			},
			input(val) {
				this.$emit("input", val);
			},

			updateData(items)
			{
				this.$emit("loadDataInitial", items)
			}
		},

		created() {
			this.config = {
				url: _sCostCenter.getUrlSearchCostCenter(),
				title: this.label,
				params: {
					NtpID : this.$fun.getUserInfo().NtpID,
					CceLevel : this.CceLevel
					/* search: '' */
				},
			};
		},
	}
</script>